import React from 'react';

const CSPAnomaliesTab = ({ anomalies }) => {
  if (!anomalies) return null;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-red-50 border border-red-200 rounded-xl p-4">
          <p className="text-red-600 text-sm">Critical</p>
          <p className="text-3xl font-bold text-red-700">{anomalies.by_severity?.critical || 0}</p>
        </div>
        <div className="bg-orange-50 border border-orange-200 rounded-xl p-4">
          <p className="text-orange-600 text-sm">High</p>
          <p className="text-3xl font-bold text-orange-700">{anomalies.by_severity?.high || 0}</p>
        </div>
        <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
          <p className="text-yellow-600 text-sm">Medium</p>
          <p className="text-3xl font-bold text-yellow-700">{anomalies.by_severity?.medium || 0}</p>
        </div>
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
          <p className="text-blue-600 text-sm">Low</p>
          <p className="text-3xl font-bold text-blue-700">{anomalies.by_severity?.low || 0}</p>
        </div>
      </div>

      <div className="bg-white rounded-xl border shadow-sm p-6">
        <h3 className="font-semibold text-gray-900 mb-4">
          Detected Anomalies ({anomalies.total_anomalies})
        </h3>
        <div className="space-y-3">
          {anomalies.anomalies?.map((anomaly) => (
            <div key={anomaly.id} className={`p-4 rounded-lg border-l-4 ${anomaly.severity === 'critical' ? 'bg-red-50 border-red-500' : anomaly.severity === 'high' ? 'bg-orange-50 border-orange-500' : anomaly.severity === 'medium' ? 'bg-yellow-50 border-yellow-500' : 'bg-blue-50 border-blue-500'}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-medium">{anomaly.type.replace(/_/g, ' ').toUpperCase()}</span>
                    <span className={`px-2 py-0.5 rounded text-xs ${anomaly.severity === 'critical' ? 'bg-red-200 text-red-700' : anomaly.severity === 'high' ? 'bg-orange-200 text-orange-700' : anomaly.severity === 'medium' ? 'bg-yellow-200 text-yellow-700' : 'bg-blue-200 text-blue-700'}`}>{anomaly.severity}</span>
                    <span className="text-xs text-gray-500">{anomaly.category}</span>
                  </div>
                  <p className="text-sm text-gray-600">Affected devices: {anomaly.affected_devices}</p>
                  {anomaly.ioc_indicators?.ip_addresses?.length > 0 && (
                    <p className="text-xs text-gray-500 mt-1">IoC IPs: {anomaly.ioc_indicators.ip_addresses.slice(0, 3).join(', ')}</p>
                  )}
                </div>
                <span className={`px-2 py-0.5 rounded text-xs ${anomaly.status === 'active' ? 'bg-red-100 text-red-700' : anomaly.status === 'investigating' ? 'bg-yellow-100 text-yellow-700' : 'bg-green-100 text-green-700'}`}>{anomaly.status}</span>
              </div>
              {anomaly.recommended_actions?.length > 0 && (
                <div className="mt-2 pt-2 border-t border-gray-200">
                  <p className="text-xs font-medium text-gray-700">Recommended Actions:</p>
                  <ul className="text-xs text-gray-600 mt-1">
                    {anomaly.recommended_actions.map((action) => (<li key={action}>• {action}</li>))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CSPAnomaliesTab;
